import { observer } from 'mobx-react-lite';

import { useStore } from 'hooks/useStore';
import { interpolate } from 'utils/string/format';

import { SMS } from '../SMS';

import css from './Prices.module.css';

const Prices = () => {
  const {
    app: { i18n },
    savedFilters: { popup },
    profile,
    view,
  } = useStore();

  if (!popup || !popup?.smsParams) return null;

  if (popup.hasOnlyPersonalBoards) {
    return (
      <div className={css.item}>
        <strong>{i18n.subscriptions.freeSubscription}</strong> <SMS />
      </div>
    );
  }

  const {
    channels: { sms },
    notificationsRate,
    smsParams,
    hasSubscriptionTrial,
    expectedNotificationsCount,
    validationResult,
  } = popup;

  if (!notificationsRate) return null;

  const formattedSubscriptionRate = view.atisCount(Number(notificationsRate));
  const formattedSmsRate = view.atisCount(smsParams?.rate);

  const hasFixedPrice = popup.validationResult?.resultFilter.subscription?.rate;

  const notificationsRatePerDay = view.atisCount(expectedNotificationsCount * notificationsRate);

  return (
    <>
      {!profile.hasUnlimitedNotificationsLicense && !hasSubscriptionTrial && (
        <div className={css.item}>
          <strong>
            {[
              interpolate(i18n.subscriptions.paidSubscription, { atis: formattedSubscriptionRate }),
              sms.value && interpolate(i18n.subscriptions.smsNotificationPrice, { atis: formattedSmsRate }),
            ]
              .filter(Boolean)
              .join(', ')}
          </strong>
        </div>
      )}

      <div className={css.item}>
        {i18n.filterPopup.expectedCount}{' '}
        <strong>{view.pluralizedCount(expectedNotificationsCount, 'notification')}</strong>
        {!profile.hasUnlimitedNotificationsLicense && !hasSubscriptionTrial && Boolean(notificationsRatePerDay) && (
          <>
            {<span> {i18n.common.for}</span>}&nbsp;
            <strong>{notificationsRatePerDay} </strong>
            <span>{i18n.common.perDay}</span>
          </>
        )}
        {Boolean(sms.value) && smsParams.rate && Boolean(expectedNotificationsCount) && (
          <>
            {(hasSubscriptionTrial || profile.hasUnlimitedNotificationsLicense) && <span> {i18n.common.free}</span>}{' '}
            <span>{i18n.filterPopup.andSameSmsCount}</span>{' '}
            <strong>{view.atisCount(expectedNotificationsCount * smsParams.rate) || 0} </strong>
          </>
        )}
      </div>

      {hasFixedPrice && !profile.hasUnlimitedNotificationsLicense && (
        <div className={css.item}>
          {i18n.subscriptions.fixedRate.firstPart}{' '}
          <strong>
            {view.atisCount(validationResult?.resultFilter.subscription.rate)} {i18n.subscriptions.fixedRate.secondPart}
          </strong>{' '}
          {i18n.subscriptions.fixedRate.couldBeChanged}
        </div>
      )}
    </>
  );
};

const connected = observer(Prices);

export { connected as Prices };
